import { useMemo, useRef } from "react";
import { hapticTap } from "./haptics";

export const useLongPress = (
  onLongPress: () => void,
  onPress?: () => void,
  delayMs = 450
) => {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const didLongPressRef = useRef(false);

  return useMemo(() => {
    const clear = () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };

    return {
      onPointerDown: (event: React.PointerEvent) => {
        if (event.pointerType === "mouse" && event.button !== 0) {
          return;
        }
        didLongPressRef.current = false;
        clear();
        timerRef.current = setTimeout(() => {
          didLongPressRef.current = true;
          hapticTap();
          onLongPress();
        }, delayMs);
      },
      onPointerUp: clear,
      onPointerLeave: clear,
      onPointerCancel: clear,
      onContextMenu: (event: React.MouseEvent) => event.preventDefault(),
      onClick: () => {
        if (didLongPressRef.current) {
          didLongPressRef.current = false;
          return;
        }
        onPress?.();
      }
    };
  }, [delayMs, onLongPress, onPress]);
};
